module.exports = "<div class=\"container press\">\n\n    <mo-header title=\"press\"></mo-header>\n\n    <main class=\"content wrapper\">\n        <aside class=\"right-aside\">\n            <a href=\"\" onclick=\"history.go(-1);\" class=\"back__button\">Back</a>\n        </aside>\n\n        <section class=\"content-box\" ng-bind-html=\"'press.text' | translate\"></section>\n\n    </main>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/modules/site/press/press.html
// module id = 548
// module chunks = 0